import { render, staticRenderFns } from "./PhoneTextField.vue?vue&type=template&id=56131c98&"
import script from "./PhoneTextField.vue?vue&type=script&lang=js&"
export * from "./PhoneTextField.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/sprite.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports